// extracted by mini-css-extract-plugin
export default {"home":"NewComplaints_home__amO2t","hr":"NewComplaints_hr__YPtXk","hr2":"NewComplaints_hr2__oj4Fk","main":"NewComplaints_main__MYPdk"};